/**
 * Constants chứa các title của các module/trang trong ứng dụng
 * Sử dụng để quản lý title một cách tập trung và dễ bảo trì
 */
export const PAGE_TITLES = {
  // module
  DASHBOARD: 'Dashboard',
  FINANCE: 'Finance',
  CARD: 'Card',
  PROVIDER: 'Provider',
  USER: 'User',
  TRANSACTION: 'Transaction',
  ACCOUNT: 'Account',
  EVENT: 'event',
  AUDIT: 'Audit',
  STABLECOIN_MANAGEMENT: 'Stablecoin Management',
  CUSTOMER: 'Customer',
  DetailCustomer: 'Customer-detail',
  CustomerDetails: 'Customer Details',
  CustomerRequest: 'Customer-request',
  LEDGER_ACCOUNTS: 'Ledger Accounts',
  JOURNALS: 'Journals',
  ENTRIES: 'Entries',
  BALANCE_CONTAINERS: 'Balance Containers',
  SEED_OPERATIONS: 'Seed Operations',
  RECONCILIATION: 'Reconciliation',
  SHARE_CARDS: 'Share Cards',
  COUNTERPART_MANAGEMENT: 'Counterpart Management',


  // Authentication
  LOGIN: 'Đăng nhập',
  REGISTER: 'Đăng ký',
  FORGOT_PASSWORD: 'Quên mật khẩu',
  RESET_PASSWORD: 'Đặt lại mật khẩu',

  // User Management
  USERS: 'User',
  USER_PROFILE: 'Thông tin cá nhân',
  USER_ROLES: 'Phân quyền người dùng',

  // Content Management
  CONTENT: 'Quản lý nội dung',
  POSTS: 'Bài viết',
  CATEGORIES: 'Danh mục',
  TAGS: 'Thẻ',

  // Settings
  SETTINGS: 'Cài đặt',
  GENERAL_SETTINGS: 'Cài đặt chung',
  SYSTEM_SETTINGS: 'Cài đặt hệ thống',

  // Reports
  REPORTS: 'Báo cáo',
  ANALYTICS: 'Phân tích',

  // Error Pages
  NOT_FOUND: 'Không tìm thấy',
  UNAUTHORIZED: 'Không có quyền truy cập',
  SERVER_ERROR: 'Lỗi máy chủ',
} as const;

// Type cho các title keys
export type PageTitleKey = keyof typeof PAGE_TITLES;
